import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from '../../../actions/index.types'
import { toast } from 'react-toastify';
import * as req from '../../../../axios/request/SocietyPortal/DocumentSeriesReqs/DocumentSeriesReqs'


function* getDocumentSeries(action) {
    try {
        const result = yield call(req.getDocumentSeriesReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_DOCUMENT_SERIES_SUCCESS, payload: result });
        } else {
            yield put({ type: types.GET_DOCUMENT_SERIES_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to fetch document series");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_DOCUMENT_SERIES_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* getDocumentSeriesDetails(action) {
    try {
        const result = yield call(req.getDocumentSeriesDetailsReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_DOCUMENT_SERIES_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_DOCUMENT_SERIES_DETAILS_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to fetch details");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_DOCUMENT_SERIES_DETAILS_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* createDocumentSeries(action) {
    try {
        const result = yield call(req.createDocumentSeriesReq, action);
        if (result.success === true) {
            toast.success(result.message || "Document series created successfully");
            yield put({ type: types.CREATE_DOCUMENT_SERIES_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.CREATE_DOCUMENT_SERIES_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to create document series");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.CREATE_DOCUMENT_SERIES_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* updateDocumentSeries(action) {
    try {
        const result = yield call(req.updateDocumentSeriesReq, action);
        if (result.success === true) {
            toast.success(result.message || "Document series updated successfully");
            yield put({ type: types.UPDATE_DOCUMENT_SERIES_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.UPDATE_DOCUMENT_SERIES_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to update document series");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.UPDATE_DOCUMENT_SERIES_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* deleteDocumentSeries(action) {
    try {
        const result = yield call(req.deleteDocumentSeriesReq, action);
        if (result.success === true) {
            toast.success(result.message || "Document series deleted successfully");
            yield put({ type: types.DELETE_DOCUMENT_SERIES_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.DELETE_DOCUMENT_SERIES_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to delete document series");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.DELETE_DOCUMENT_SERIES_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* previewDocumentSeries(action) {
    try {
        const result = yield call(req.previewDocumentSeriesReq, action);
        if (result.success === true) {
            yield put({ type: types.PREVIEW_DOCUMENT_SERIES_NUMBER_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.PREVIEW_DOCUMENT_SERIES_NUMBER_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to preview");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.PREVIEW_DOCUMENT_SERIES_NUMBER_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}


export default function* documentSeriesSaga() {
    yield takeLatest(types.GET_DOCUMENT_SERIES, getDocumentSeries);
    yield takeLatest(types.GET_DOCUMENT_SERIES_DETAILS, getDocumentSeriesDetails);
    yield takeLatest(types.CREATE_DOCUMENT_SERIES, createDocumentSeries);
    yield takeLatest(types.UPDATE_DOCUMENT_SERIES, updateDocumentSeries);
    yield takeLatest(types.DELETE_DOCUMENT_SERIES, deleteDocumentSeries);
    yield takeLatest(types.PREVIEW_DOCUMENT_SERIES_NUMBER, previewDocumentSeries);
}
